var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCybersecurityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 824,
    y: 922,
    width: 135,
    height: 135
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-824 -922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M934.457 954.12C919.541 952.932 905.633 946.126 895.543 935.078 893.641 932.874 890.312 932.628 888.107 934.53 887.912 934.699 887.729 934.882 887.56 935.078 877.469 946.126 863.561 952.932 848.646 954.12 845.874 954.38 843.762 956.717 843.783 959.5L843.783 973.075C843.783 1002.59 862.552 1029.58 888.613 1046.29 890.403 1047.44 892.7 1047.44 894.49 1046.29 920.55 1029.58 939.32 1002.59 939.32 973.075L939.32 959.5C939.34 956.717 937.228 954.38 934.457 954.12ZM930.179 973.075C930.179 996.559 916.188 1020.25 892.753 1036.46L891.552 1037.29 890.352 1036.46C866.916 1020.25 852.922 996.552 852.922 973.075L852.922 962.878 854.7 962.597C867.943 960.503 880.269 954.533 890.122 945.441L891.551 944.125 892.981 945.441C902.834 954.533 915.159 960.503 928.401 962.597L930.179 962.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.551 949.827C881.787 958.366 869.899 964.111 857.141 966.454L857.141 973.075C857.141 994.769 869.976 1016.76 891.552 1032.15 913.125 1016.76 925.96 994.771 925.96 973.075L925.96 966.454C913.203 964.111 901.314 958.366 891.551 949.827ZM887.939 1004.73 873.719 990.513 878.551 985.681 887.939 995.069 907.166 975.843 911.997 980.676Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCybersecurityIcon);
export default __webpack_public_path__ + "static/media/cybersecurityIcon.23e3da51de095d372638c78bd30fc19d.svg";
export { ForwardRef as ReactComponent };